import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box } from '@chakra-ui/react';
import Latex from 'react-latex-next';
import { JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-divider" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is null.
 */
const DividerJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['null'], children: _jsxs(Box, { "data-testid": "DividerJsField-test", "data-name": props.name, p: "15px 0 4px 0", fontSize: "12px", fontWeight: "600", children: [_jsx(Box, { p: "0 0 2px", children: _jsx(Latex, { children: props.schema.title ?? '' }) }), _jsx(Box, { borderTop: "1px", borderColor: "border", opacity: "0.6", h: "1px" })] }) }));
};
export const DividerJsField = DividerJsFieldFC;
//# sourceMappingURL=DividerJsField.js.map